import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const EventViewModal = ({ isOpen, onClose, event, loading }) => {
  if (!isOpen) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleString("uz-UZ", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <AnimatePresence>
      <motion.div
        className="modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="modal-content"
          initial={{ scale: 0.85, y: 60 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.85, y: 60 }}
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "780px",
            borderRadius: "16px",
            padding: "32px",
            maxHeight: "92vh",
            overflowY: "auto",
          }}
        >
          <h3 style={{ margin: "0 0 28px", fontSize: "24px", fontWeight: 700 }}>
            Tadbir ma'lumotlari
          </h3>

          {loading ? (
            <div style={{ textAlign: "center", padding: "120px 0" }}>
              Yuklanmoqda...
            </div>
          ) : event ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "24px" }}
            >
              {/* Rasm */}
              {event.imageUrl && (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={event.imageUrl}
                    alt={event.title}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "380px",
                      borderRadius: "12px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/600x300?text=Rasm+mavjud+emas";
                    }}
                  />
                </div>
              )}

              <div style={{ display: "grid", gap: "16px" }}>
                <div>
                  <strong>Sarlavha:</strong> {event.title || "—"}
                </div>

                <div>
                  <strong>Boshlanish vaqti:</strong>{" "}
                  {formatDate(event.startTime)}
                </div>

                <div>
                  <strong>Tugash vaqti:</strong>{" "}
                  {formatDate(event.endTime) || "Ko‘rsatilmagan"}
                </div>

                <div>
                  <strong>Joylashuv:</strong> {event.location || "—"}
                </div>

                <div>
                  <strong>Status:</strong>{" "}
                  <span
                    style={{
                      padding: "6px 14px",
                      borderRadius: "20px",
                      background:
                        event.statusName === "Confirmed"
                          ? "#ecfdf5"
                          : event.statusName === "Created"
                          ? "#fffbeb"
                          : event.statusName === "Modified"
                          ? "#fef3f0"
                          : event.statusName === "Cancelled"
                          ? "#fef2f2"
                          : "#f3f4f6",
                      color:
                        event.statusName === "Confirmed"
                          ? "#10b981"
                          : event.statusName === "Created"
                          ? "#d97706"
                          : event.statusName === "Modified"
                          ? "#c2410c"
                          : event.statusName === "Cancelled"
                          ? "#dc2626"
                          : "#6b7280",
                    }}
                  >
                    {event.statusName === "Confirmed"
                      ? "Faol"
                      : event.statusName === "Created"
                      ? "Kutilyapti"
                      : event.statusName === "Modified"
                      ? "O‘zgartirildi"
                      : event.statusName === "Cancelled"
                      ? "Bekor qilingan"
                      : event.statusName || "—"}
                  </span>
                </div>

                {event.description && (
                  <div>
                    <strong>Tavsif:</strong>
                    <p
                      style={{
                        marginTop: "8px",
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.6,
                      }}
                    >
                      {event.description}
                    </p>
                  </div>
                )}

                <div>
                  <strong>ID:</strong>{" "}
                  <span style={{ fontFamily: "monospace", fontSize: "14px" }}>
                    {event.id}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "100px 0",
                color: "#e74c3c",
              }}
            >
              Tadbir ma'lumotlari topilmadi
            </div>
          )}

          <div style={{ marginTop: "32px", textAlign: "right" }}>
            <button
              onClick={onClose}
              style={{
                padding: "10px 28px",
                background: "#f1f5f9",
                border: "none",
                borderRadius: "8px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Yopish
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default EventViewModal;
